export enum ServersZonesEnum {
    Test = 0,
    Moscow = 1,
    Novosibirsk = 2
}